import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

import Avatar       from 'avatar';
import Connection   from 'connection';
import Dialog       from 'dialogview';
import template     from './avatar-upload-dialog.hbs';
import './avatar-upload-dialog.scss';

let Super = Dialog.prototype;

export default Dialog.extend({

    showInstant: true,
    hideInstant: true,

    template,

    className: 'avatarUploadDialog accountContainer form',

    events: _.extend({}, Super.events, {
        'submit .avatarUploadDialog__form': 'onSubmit'
    }),

    initialize (options) {
        Super.initialize.apply(this, arguments);
        
        this.model.bind('avatarPreview', this.renderPreview, this);
    },
    
    onSubmit (e) {
        e.preventDefault();
        if (this.avatar && this.cropper) {
            var canvas = this.cropper.getCroppedCanvas();
            // Recreate the blob as the originl mime type
            var dataUrl = canvas.toDataURL(this.avatar.getType());
            var blob = Avatar.blobFromDataURI(dataUrl);
            blob.name = this.avatar.getName();
            var avatar = Avatar.fromFile(blob, this.model);
            var cropData = this.cropper.getData(true);
            var data = $(e.currentTarget).serializeForm();
            avatar.set({
                width: cropData.width,
                height: cropData.height,
                is_primary: data.primary == '1'
            });
            avatar.bind('avatar-uploadSuccess', function () {
                avatar.cacheDataUrl(dataUrl);
                this.hide();
            }, this);
            avatar.bind('avatar-uploadError', function () {
                this.model.trigger('postError', avatar.getError());
            }, this);
            this.finalise(avatar, dataUrl);
        }
    },
    
    finalise (avatar, dataUrl) {
        this.model.trigger('finaliseAvatarFromPromise', avatar, dataUrl);
    },
        
    render () {
        this.$el.html(this.template());
        this.afterRender();
        return this;
    },

    afterRender () {
        this.cropperWrapper = this.$('.avatarCropper__wrapper');
        this.cropperImg = this.cropperWrapper.find('.avatarCropper__image');
    },

    closed () {
        this.localFileData = null;
        this.avatar = null;
        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
        Super.closed.apply(this, arguments);
    },
    
    renderPreview (target, avatar, options) {
        var primary = (target === this.model);
        this.localFileData = null;
        this.avatar = avatar;
        
        if (this.avatar.localFile && window.FileReader) {
            this.readFileData().done(_.bind(function (src) {
                if (target instanceof Connection) {
                    this.$('.avatarChooser__nick').text(target.getNick());
                    this.$('.avatarChooser__network').text(target.getDisplayName());
                    this.$('.avatarChooser__connection').show();
                } else {
                    this.$('.avatarChooser__connection').hide();
                }
                this.$('.avatarUploadDialog__set-default').toggle(!primary);
                this.show();
                this.initCropper();
            }, this));
        } else {
            // No preview possible, finalise
            this.finalise(this.avatar);
        }
    },
    
    readFileData () {
        var fileRead = new $.Deferred().done(_.bind(function (src) {
            this.localFileData = src;
        }, this));
        if (this.localFileData) {
            fileRead.resolve(this.localFileData);
        } else {
            var reader = new window.FileReader();
            reader.onload = function (e) {
                fileRead.resolve(e.target.result);
            };
            reader.readAsDataURL(this.avatar.localFile);
        }
        return fileRead.promise();
    },
    
    initCropper () {
        this.$el.addClass('avatarEditor--cropper');
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropperImg.attr('src', this.localFileData).one('load', (e) => {
            let isSquare = this.cropperImg[0].width === this.cropperImg[0].height;
            let autoCrop = isSquare ? 1 : 0.8;
            this.cropper = new Cropper(this.cropperImg[0], {
                viewMode: 2,
                aspectRatio: 1,
                autoCropArea: autoCrop,
                toggleDragModeOnDblclick: false,
                preview: '.avatarPreview__previewThumb',
                minCropBoxWidth: 32,
                minCropBoxHeight: 32,
                zoomable: false
            });
        });
    },
});



// WEBPACK FOOTER //
// ./app/src/view/avatar-upload-dialog.es6